// Cache em memória da Carteira por emissão (payload de POST /v1/carteira — ver
// carteiraModel.js). O banco já devolve os 7 cortes prontos ("0" a "6") numa
// única resposta, então cacheia pra sempre por sessão, sem janela de meses —
// exceto o corte "0" (Hoje), que fica estático até o próximo fetch (mesma
// limitação que já existia implicitamente antes; não há invalidação por
// virada de dia, fora de escopo).
import { postCarteira } from './fluxoCaixaApi';

const cache = new Map(); // emissaoId (string, "g:"-prefixada no convidado) -> payload de postCarteira | null

// Promise em voo por emissaoId — evita bulk duplicado se dois consumidores
// chamarem getCarteiraCached quase ao mesmo tempo antes da 1ª resposta chegar
// (StrictMode, Painel e Detalhe2 montando perto um do outro). Mesmo princípio
// de `_fullInFlight` em fluxoCaixaApi.js.
const _inFlight = new Map();

// Retorna { [emissaoId]: payload | null }. Falha de rede em uma emissão não
// impede as outras. Cache-key prefixada com "g:" pro preview de convidado
// (toggle "visão pública" de Detalhe2.jsx) — namespace separado do cache real,
// senão um recorte vaza pro outro ao alternar o toggle (mesmo esquema de
// saldoDevedorCache.js).
export async function getCarteiraCached(emissaoIds, comoConvidado) {
  const ck = id => (comoConvidado ? `g:${id}` : String(id));
  const need = emissaoIds.filter(id => !cache.has(ck(id)));
  const toFetch = need.filter(id => !_inFlight.has(ck(id)));

  if (toFetch.length) {
    // Só cacheia em caso de sucesso — se a request falhar (500, rede, etc.), os ids
    // ficam de fora do cache pra serem tentados de novo na próxima chamada, em vez de
    // ficarem presos como "sem dado" (null) pro resto da sessão da SPA.
    const promise = postCarteira(toFetch.map(Number), comoConvidado).then(map => {
      toFetch.forEach(id => { cache.set(ck(id), map[id] || null); });
      return map;
    }).catch(() => ({}));
    toFetch.forEach(id => _inFlight.set(ck(id), promise));
    promise.finally(() => { toFetch.forEach(id => _inFlight.delete(ck(id))); });
  }

  const joining = [...new Set(need.filter(id => _inFlight.has(ck(id))).map(id => _inFlight.get(ck(id))))];
  if (joining.length) await Promise.all(joining);

  const out = {};
  emissaoIds.forEach(id => { out[id] = cache.get(ck(id)) || null; });
  return out;
}

export function clearCarteiraCache() { cache.clear(); _inFlight.clear(); }
